(function ($) {
	$(document).ready(function () {
		if (new MobileDetect(window.navigator.userAgent).mobile()) {
			$("body").addClass("mia-js-mobile");
		} else {
			$("body").addClass("mia-js-desktop");
		}
	});
})(jQuery);
